import { Gender } from "constants/enums";

import { NotificationFormValues } from "../components";
import { NotificationRepetitionType } from "./enums";

export * from "./enums";

export const EMPTY_NOTIFICATION_FORM_VALUES: NotificationFormValues = {
  title: "",
  description: "",
  postingDate: null,
  postingTime: null,
  image: null,
  repetition: {
    every: 1,
    type: NotificationRepetitionType.Daily,
    neverRepeat: false
  },
  productVariants: [],
  productSet: null,
  targetGender: Gender.All,
  age: [1, 100],
  notRelevantAge: true,
  earnings: [1, 9999999],
  notRelevantEarnings: true,
  salesType: "moreThan",
  salesValue: 1,
  notRelevantSales: true,
  sharesType: "moreThan",
  sharesValue: 1,
  notRelevantShares: true
};
